import React from 'react';
import moment from "moment";
import {getCurrentFinancialYear, timeStampUnix} from "../../common/functions/common";
import {dateFormatter} from "ubs-framework/v2/common/date";
import {PAGINATION} from "../../common/constant";

const initialState = {
    socketId: '',
    _id: '',
    dashboardPayroll: {},
    accessID: '',
    payRollDropDown: {
        label: `${dateFormatter({date: moment(new Date).subtract(1, 'months'), format: 'MMMM'})} - ${dateFormatter({date: moment(new Date).subtract(1, 'months'), format: 'YYYY'})}`,
        value: timeStampUnix(moment(new Date).subtract(1, 'months'))
    },
    document: {
        letterType: '',
        name: '',
        design: 'blank'
    },
    letterTypeId: "",
    searchLetterType: "",
    inbox: [],
    settingsLeaveTypePolicy:{
        activePolicyId:"",
        isHourly:false,
    },
    employeeTaxRegimeReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        taxRegime: {value: '', label: 'All'},
        year:getCurrentFinancialYear(),
        userIds: []
    },
    salaryTemplateGuest: {
        data: null,
        userId: null,
        templateId: null,
        isTemplateCreated: false,
    },
    location: {
        lat: 0,
        lng: 0,
        address: "",
        permission: "",
        mocked: false
    },
    employeeRouteFilter: {
        date: new Date(),
        user: null,
    },
    mheProductivity : {editData : null},
    version: 0,
    release: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) data._id = action.payload._id
            return {...state, ...data};
        }

        case 'SET_ACCESS_ID': {
            return {...state, accessID: action.payload}
        }

        case 'PAYROLL_DASHBOARD': {
            return {...state, dashboardPayroll: {...state.dashboardPayroll, ...action.payload}};
        }

        case 'PAYROLL_PROCESS_DROPDOWN_SELECTED': {
            return {...state, payRollDropDown: action.payload};
        }
        case 'SET_DOCUMENT': {
            return {...state, document: {...state.document, ...action.payload}};
        }
        case 'SET_LETTER_ID': {
            return {...state, letterTypeId: action.payload};
        }
        case 'SEARCH_LETTER_TYPE': {
            return {...state, searchLetterType: action.payload};
        }
        case 'SET_INBOX_COUNT': {
            return {...state, inbox: {...state.inbox, ...action.payload}};
        }
        case 'SETTINGS_LEAVE_TYPE_POLICY': {
            return {...state, settingsLeaveTypePolicy: {...state.settingsLeaveTypePolicy,...action.payload}};
        }
        case 'SET_MY_TAX_REGIME_REPORT': {
            return {...state, employeeTaxRegimeReport: {...state.employeeTaxRegimeReport, ...action.payload}};
        }
        case 'SALARY_TEMPLATE_GUEST_USER': {
            if(action.payload?.type === "setData"){
                return {...state, salaryTemplateGuest: { ...state?.salaryTemplateGuest , ...(action.payload?.payload || {}) }};
            }else if(action?.payload?.type === "clear"){
                return {...state, salaryTemplateGuest: { ...state?.salaryTemplateGuest , data: null, userId: null, templateId: null, isTemplateCreated: false,}};
            }
            return state;
        }
        case 'UPDATE_LOCATION' : {
            return {...state, location: {...state.location, ...action.payload}}
        }
        case 'SET_EMPLOYEE_ROUTE_FILTER': {
            return {...state, employeeRouteFilter: {...state.employeeRouteFilter, ...action.payload}};
        }
        case "SET_MHE_PROD_EDIT": {
            return {...state, mheProductivity: {...state.mheProductivity, ...action.payload}};
        }
        case 'SET_LATEST_VERSION':
            return {...state, version: action.payload.version, release: action.payload};
        default: {
            // return {...initialState, ...state};
            return state;
        }
    }
}

